import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { Chip } from "shared/ui/chip/Chip"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

import "../styles/_project-team-invitation-card.scss"

interface ProjectTeamInvitationCardLoaderProps extends WithClassName {}

export const ProjectTeamInvitationCardLoader = React.memo(
  ({ className }: ProjectTeamInvitationCardLoaderProps) => {
    return (
      <div
        className={classNames(
          "card",
          "project-team-invitation-card",
          "project-team-invitation-card--loading",
          className
        )}
      >
        <div className="project-team-invitation-card__content">
          <div className="project-team-invitation-card__meta-data">
            <Skeleton
              className={classNames("project-team-invitation-card__status")}
            />

            <h4 className="project-team-invitation-card__title">
              <Skeleton />
            </h4>

            <div className="project-team-invitation-card__invited-by">
              <Skeleton />
            </div>

            <div className="project-team-invitation-card__tags">
              <Chip
                className="chip--small project-team-invitation-card__tag"
                isLoading
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
)
